__turbopack_context__.v({
  "actions": "PrivacyPolicyChange2026Modal-module__1mWorW__actions",
  "body": "PrivacyPolicyChange2026Modal-module__1mWorW__body",
  "content": "PrivacyPolicyChange2026Modal-module__1mWorW__content",
  "errorMessage": "PrivacyPolicyChange2026Modal-module__1mWorW__errorMessage",
  "title": "PrivacyPolicyChange2026Modal-module__1mWorW__title",
});
